// add button icon
export const SvgAdd = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="14" height="14" rx="7" fill="white" fillOpacity="0.6" />
    <path d="M4 7H10" stroke="#7C68FB" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M7 10L7 4" stroke="#7C68FB" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// create/add block icon
export const SvgCreate = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="10" width="60" height="60" rx="30" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 48C38 49.1046 38.8954 50 40 50C41.1046 50 42 49.1046 42 48V42H48C49.1046 42 50 41.1046 50 40C50 38.8954 49.1046 38 48 38H42V32C42 30.8954 41.1046 30 40 30C38.8954 30 38 30.8954 38 32L38 38H32C30.8954 38 30 38.8954 30 40C30 41.1046 30.8954 42 32 42H38L38 48Z"
      fill="white"
    />
  </svg>
);

// delete button icon
export const SvgTrash = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2123 12.2205L15.4309 10.6496C15.4982 10.1663 15.5597 9.72444 15.6143 9.31913C15.7267 8.48621 15.7828 8.06975 15.5338 7.78488C15.2848 7.50002 14.8568 7.50002 14.0007 7.50002H5.99912C5.1431 7.50002 4.71509 7.50002 4.46606 7.78488C4.21704 8.06975 4.2732 8.48621 4.38552 9.31913C4.44019 9.72456 4.50164 10.1661 4.56893 10.6496L4.78754 12.2205C5.02514 13.9277 5.14394 14.7814 5.39583 15.467C5.86687 16.749 6.68111 17.7039 7.65297 18.114C8.17267 18.3334 8.78177 18.3334 9.99993 18.3334C11.2181 18.3334 11.8272 18.3334 12.3469 18.114C13.3187 17.7039 14.133 16.749 14.604 15.467C14.8559 14.7814 14.9747 13.9277 15.2123 12.2205ZM8.95825 9.16669C8.95825 8.82151 8.67843 8.54169 8.33325 8.54169C7.98807 8.54169 7.70825 8.82151 7.70825 9.16669V15.8334C7.70825 16.1785 7.98807 16.4584 8.33325 16.4584C8.67843 16.4584 8.95825 16.1785 8.95825 15.8334V9.16669ZM12.2916 9.16669C12.2916 8.82151 12.0118 8.54169 11.6666 8.54169C11.3214 8.54169 11.0416 8.82151 11.0416 9.16669V15.8334C11.0416 16.1785 11.3214 16.4584 11.6666 16.4584C12.0118 16.4584 12.2916 16.1785 12.2916 15.8334V9.16669Z"
      fill="currentColor"
    />
    <path
      d="M9.99992 1.04169C7.81379 1.04169 6.04159 2.81389 6.04159 5.00002V5.20835H3.33325C2.98807 5.20835 2.70825 5.48818 2.70825 5.83335C2.70825 6.17853 2.98807 6.45835 3.33325 6.45835H16.6666C17.0118 6.45835 17.2916 6.17853 17.2916 5.83335C17.2916 5.48818 17.0118 5.20835 16.6666 5.20835H13.9583V5.00002C13.9583 2.81389 12.186 1.04169 9.99992 1.04169Z"
      fill="currentColor"
    />
  </svg>
);

// search input left icon
export const SvgSearch = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_815_375)">
      <path
        d="M12.9761 11.6907C12.8052 11.5199 12.5282 11.5199 12.3574 11.6907C12.1865 11.8616 12.1865 12.1386 12.3574 12.3094L12.9761 11.6907ZM15.024 14.9761C15.1948 15.1469 15.4718 15.1469 15.6427 14.9761C15.8135 14.8052 15.8135 14.5282 15.6427 14.3574L15.024 14.9761ZM12.3574 12.3094L15.024 14.9761L15.6427 14.3574L12.9761 11.6907L12.3574 12.3094ZM7.33334 12.2292C4.26126 12.2292 1.77084 9.73877 1.77084 6.66669H0.895843C0.895843 10.222 3.77801 13.1042 7.33334 13.1042V12.2292ZM12.8958 6.66669C12.8958 9.73877 10.4054 12.2292 7.33334 12.2292V13.1042C10.8887 13.1042 13.7708 10.222 13.7708 6.66669H12.8958ZM7.33334 1.10419C10.4054 1.10419 12.8958 3.5946 12.8958 6.66669H13.7708C13.7708 3.11135 10.8887 0.229187 7.33334 0.229187V1.10419ZM7.33334 0.229187C3.77801 0.229187 0.895843 3.11135 0.895843 6.66669H1.77084C1.77084 3.5946 4.26126 1.10419 7.33334 1.10419V0.229187Z"
        fill="#667085"
      />
    </g>
    <defs>
      <clipPath id="clip0_815_375">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// button search icon filled
export const SvgSearch1 = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.6665 8.33337C1.6665 4.19124 5.02437 0.833374 9.1665 0.833374C13.3086 0.833374 16.6665 4.19124 16.6665 8.33337C16.6665 12.4755 13.3086 15.8334 9.1665 15.8334C5.02437 15.8334 1.6665 12.4755 1.6665 8.33337ZM8.29864 3.28687C8.35263 3.6278 8.12003 3.94795 7.7791 4.00195C6.26365 4.24197 5.0751 5.43052 4.83508 6.94597C4.78108 7.2869 4.46093 7.5195 4.12 7.46551C3.77907 7.41151 3.54647 7.09136 3.60047 6.75043C3.92521 4.70011 5.53324 3.09208 7.58356 2.76734C7.92449 2.71334 8.24464 2.94594 8.29864 3.28687Z"
      fill="#A395FC"
    />
    <path
      d="M15.3912 14.5581C15.6353 14.314 16.031 14.314 16.2751 14.5581L19.6084 17.8914C19.8524 18.1355 19.8524 18.5312 19.6084 18.7753C19.3643 19.0194 18.9685 19.0193 18.7245 18.7753L15.3912 15.442C15.1471 15.1979 15.1472 14.8022 15.3912 14.5581Z"
      fill="#A395FC"
    />
  </svg>
);

// button import qa icon
export const SvgFile = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 10C17.5 6.87522 17.5 5.31283 16.7042 4.21756C16.4472 3.86383 16.1362 3.55276 15.7824 3.29576C14.6872 2.5 13.1248 2.5 10 2.5C6.87522 2.5 5.31284 2.5 4.21756 3.29576C3.86383 3.55276 3.55276 3.86383 3.29576 4.21756C2.5 5.31283 2.5 6.87522 2.5 10C2.5 10.6991 2.5 11.32 2.50891 11.875L2.56735 11.875C3.27736 11.8749 3.70985 11.8749 4.08292 11.934C6.13323 12.2587 7.74127 13.8668 8.06601 15.9171C8.12509 16.2901 8.12506 16.7226 8.125 17.4326L8.125 17.4911C8.67997 17.5 9.30088 17.5 10 17.5C13.1248 17.5 14.6872 17.5 15.7824 16.7042C16.1362 16.4472 16.4472 16.1362 16.7042 15.7824C17.5 14.6872 17.5 13.1248 17.5 10ZM13.3333 6.04167C13.6785 6.04167 13.9583 6.32149 13.9583 6.66667C13.9583 7.01184 13.6785 7.29167 13.3333 7.29167H10.8333C10.4882 7.29167 10.2083 7.01184 10.2083 6.66667C10.2083 6.32149 10.4882 6.04167 10.8333 6.04167H13.3333ZM13.3333 9.375C13.6785 9.375 13.9583 9.65482 13.9583 10C13.9583 10.3452 13.6785 10.625 13.3333 10.625H6.66667C6.32149 10.625 6.04167 10.3452 6.04167 10C6.04167 9.65482 6.32149 9.375 6.66667 9.375H13.3333ZM13.3333 12.7083C13.6785 12.7083 13.9583 12.9882 13.9583 13.3333C13.9583 13.6785 13.6785 13.9583 13.3333 13.9583H10.8333C10.4882 13.9583 10.2083 13.6785 10.2083 13.3333C10.2083 12.9882 10.4882 12.7083 10.8333 12.7083H13.3333Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path
      d="M3.88737 13.1686C3.63038 13.1279 3.31306 13.1251 2.55445 13.125C2.63312 14.3247 2.82547 15.1351 3.29576 15.7824C3.55276 16.1362 3.86383 16.4472 4.21756 16.7042C4.86486 17.1745 5.67531 17.3669 6.875 17.4456C6.87489 16.6869 6.8721 16.3696 6.8314 16.1126C6.59137 14.5972 5.40283 13.4086 3.88737 13.1686Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

export const SvgWarning = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 14C22 19.5228 17.5228 24 12 24C6.47715 24 2 19.5228 2 14C2 8.47715 6.47715 4 12 4C17.5228 4 22 8.47715 22 14ZM12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V9C11.25 8.58579 11.5858 8.25 12 8.25ZM12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
      fill="#F04438"
    />
  </svg>
);

export const SvgLightWarning = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
    <path d="M12 8v4"></path>
    <path d="M12 16h.01"></path>
  </svg>
);

export const SvgEditNew = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.85808 12.8287L9.35293 12.2741C9.96011 11.5936 11.0495 11.682 11.5389 12.4516C11.9948 13.1684 12.9854 13.3043 13.6175 12.7368L14.5145 11.9314M2.48633 12.98L5.39698 12.3936C5.5515 12.3624 5.69338 12.2863 5.80481 12.1749L12.3206 5.6555C12.633 5.34293 12.6328 4.83627 12.3201 4.52397L10.9398 3.14525C10.6273 2.83307 10.1209 2.83328 9.80863 3.14572L3.29217 9.66576C3.18096 9.77703 3.10503 9.91862 3.07386 10.0728L2.48633 12.98Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
